import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar, FavListX } from '../components';
import coins from '../data/favoriteCoins.json';

const tronConcept = require('../assets/images/tron-concept-01.jpg');

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 2px 0;
`;

const FavoritesX = ({ theme }) => (
  <Screen theme={theme} title="Favorites X" customBg={tronConcept}>
    <TopNavBar title="Coinmend" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content>
      <FavListX coins={coins} />
    </Content>
    <BottomTabBar selected="favorites" />
  </Screen>
);

export default withTheme(FavoritesX);



// WEBPACK FOOTER //
// ./src/containers/FavoritesX.js